import { render, staticRenderFns } from "./SalesTaxTransactionTile.vue?vue&type=template&id=285c5177&scoped=true&"
import script from "./SalesTaxTransactionTile.vue?vue&type=script&lang=js&"
export * from "./SalesTaxTransactionTile.vue?vue&type=script&lang=js&"
import style0 from "./SalesTaxTransactionTile.vue?vue&type=style&index=0&id=285c5177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285c5177",
  null
  
)

export default component.exports